import http from '../../http'

let send_m = (data) => {
  // 按标签和分组发送短信
  return http.post('marketcenter/sms2/markcenter/send', data)
}
let send_person = (data) => {
  // 按标签和分组发送短信
  return http.post('marketcenter/sms2/send', data)
}
let getTemplateList = (params) => {
  return http.get('marketcenter/sms/template/get/audited', params)
}

let getTemplate  = (params) => {
  return http.get('marketcenter/sms/template/get', params)
}
let saveTemplate = (data) => {
  return http.post('marketcenter/sms/template/save', data)
}

let deleteTemplate = (params) => {
  return http.get('marketcenter/sms/template/delete', params)
}

let getInsertField = (params) => {
  return http.get('marketcenter/sms/markcenter/field', params)
}

export default {
  send: (params) => {
    // 活动中心发短信-通知类
    return http.post('marketcenter/sms/send', params)
  },
  sendyx: (params) => {
    // 活动中心发短信-营销类
    return http.post('marketcenter/sms/send/yx', params)
  },
  getMassageList: (data) => {
    return http.post('marketcenter/sms/task/get', data)
  }, //获取短信列表
  getTimeMessageList: (data) => {
    return http.post('marketcenter/sms/timer/task/get', data)
  },//获取定时发送短信
  updataTimeMessage: (data) => {
    return http.post('marketcenter/sms/timer/task/update', data)
  },//更新定时任务
  getMassageReport: (data) => {
    return http.post('marketcenter/sms/report/get', data)
  }, //获取短信报表
  getMassageReportDetail: (data) => {
    return http.post('marketcenter/sms/detail/get', data)
  }, //获取短信报表详情
  getReportDetailStats: (params) => {
    return http.get('marketcenter/sms/precent/get', params)
  }, //获取短信详情的统计信息
  deleteSms: (params) => {
    return http.post('marketcenter/sms/task/del', params)
  }, //删除短信信息
  deleteTimerSms: (params) => {
    return http.post('marketcenter/sms/timer/task/del', params)
  }, //删除定时短信任务（POST 方式）
  deleteTimerSmsGet: (params) => {
    return http.get('marketcenter/sms/timer/task/del', params)
  }, //删除定时短信任务（GET 方式）

  send_m,
  send_person,
  getTemplateList,
  getTemplate,//获取短信模板列表
  saveTemplate, //保存短信模板
  deleteTemplate, //删除短信模板
  getInsertField, //营销中心  获取插入短信字段
}
